<script>
  import {Line, mixins} from 'vue-chartjs'

  export default ({
    extends: Line,
    mixins: [mixins.reactiveProp],
    name: 'LineChart',
    props: ['chartData'],
    mounted () {
      this.renderChart(this.chartData, {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        plugins: {
          datalabels: {
            display: false
          }
        }
      })
    }
  })
</script>


// WEBPACK FOOTER //
// src/components/widgets/charts/LineChart.vue